// src/components/PublicRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';



const PublicRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem("authToken");
            if (!token) {
                setAuthenticated(false);
                setLoading(false);
                return;
            }

            try {
                await axios.get(`${API}/user/profile`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setAuthenticated(true);
            } catch (err) {
                setAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    if (loading) return <div><div className="flex items-center justify-center h-screen bg-gray-100">
        <Loader2 className="animate-spin text-purple-600 w-16 h-16" />
    </div></div>;

    return authenticated ? <Navigate to="/" replace /> : children;
};

export default PublicRoute;
